import { useEffect, useState } from "react";

import { apiRoot } from "../constants";
import { useAuth } from "./useAuth";

const useEvents = () => {
  const [events, setEvents] = useState([]);
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);
  const { token, authed, cityId } = useAuth();

  useEffect(() => {
    setLoading(true);
    const headers = {
      "Content-Type": "application/json",
    };
    if (authed) {
      headers["Authorization"] = `Token ${token}`;
    }
    let url = "/events";
    if (cityId) {
      url = `/cities/${cityId}/events`;
    }
    fetch(`${apiRoot}${url}`, {
      headers,
    })
      .then((resp) => {
        if (resp.status === 200) {
          resp.json().then((json) => {
            setEvents(json);
            setError(false);
            setLoading(false);
          });
        } else {
          setError(true);
          setEvents([]);
          setLoading(false);
        }
      })
      .catch((err) => {
        setError(true);
        setEvents([]);
        setLoading(false);
      });
  }, [authed, token, cityId]);

  return {
    events,
    error,
    loading,
  };
};

export default useEvents;
